import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../../../shared/loader/Loader";
import { useTranslation } from "react-i18next";
import EcoProButton from "../../../../shared/button/button";
import './SupplyOrderLogs.css';
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { SUCCESS } from "../../../../../constants/AppConstants";

const SupplyOrderLogs = (props) => {
  const { handleSupplyOrderLogs } = props;
  const { t } = useTranslation(['CSAgenttranslation']);
  const supplyOrderLogs = useSelector(state => state.CSAGENT.SupplyOrderLogs);
  const TABS = {
    'SUPPLY_ORDER_LOG': 'SUPPLY_ORDER_LOG'
  }

  const [activeTab, setActiveTab] = useState((supplyOrderLogs?.supplyOrderLogs?.result?.length > 0)
    ? supplyOrderLogs?.supplyOrderLogs?.result[0].deviceId
    : null);

  useEffect(() => {
    if (supplyOrderLogs && supplyOrderLogs?.supplyOrderLogs?.actionStatus?.toUpperCase() === SUCCESS) {
      if ((supplyOrderLogs?.supplyOrderLogs?.result?.length > 0)) {
        setActiveTab(supplyOrderLogs?.supplyOrderLogs?.result[0]?.deviceId);
      } else {
        setActiveTab(TABS.SUPPLY_ORDER_LOG);
      }
    }
  }, [TABS.SUPPLY_ORDER_LOG, supplyOrderLogs]);

  return (
    supplyOrderLogs.loading ? <Loader></Loader> :
      supplyOrderLogs.success ?
        <div className="email-log-container">
          <div className="supply-order-logs-refresh-btn">
            <EcoProButton cname="default white-bg-btn" onBtnClick={() => handleSupplyOrderLogs()}>{t('REFRESH_BTN_TEXT')}</EcoProButton>
          </div>
          <div className="tab-btn-wrapper">
            <div>
              <Nav tabs>
                {(supplyOrderLogs?.supplyOrderLogs?.result?.length > 0) ?
                  supplyOrderLogs?.supplyOrderLogs?.result.map((supplyLog) => (
                    <NavItem>
                      <NavLink active={activeTab === supplyLog.deviceId} onClick={() => setActiveTab(supplyLog.deviceId)}>
                        {supplyLog.serialNumber}
                      </NavLink>
                    </NavItem>
                  )) :
                  <NavItem>
                    <NavLink active={activeTab === TABS.SUPPLY_ORDER_LOG} onClick={() => setActiveTab(TABS.SUPPLY_ORDER_LOG)}>
                      {t('CUSTOMER_DASHBOARD.TAB_ITEMS.SUPPLY_ORDER_LOGS')}
                    </NavLink>
                  </NavItem>
                }
              </Nav>
            </div>
          </div>
          <div className="supply-order-log-content-wrapper">
            <TabContent activeTab={activeTab}>
              {
                (supplyOrderLogs?.supplyOrderLogs?.result?.length > 0) ?
                  supplyOrderLogs?.supplyOrderLogs?.result.map((supplyLog) => (
                    <TabPane tabId={supplyLog.deviceId}>
                      <table className="table cs-agent-supply-order-logs-table">
                        <thead>
                          <tr>
                            <th scope="col">{t('SUPPLY_ORDER_LOGS.TABLE_HEAD.DATETIME')}</th>
                            <th scope="col">{t('SUPPLY_ORDER_LOGS.TABLE_HEAD.ITEMS')}</th>
                            <th scope="col">{t('SUPPLY_ORDER_LOGS.TABLE_HEAD.STATUS')}</th>
                            <th scope="col">{t('SUPPLY_ORDER_LOGS.TABLE_HEAD.ORDER_ID')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            supplyLog.logs?.map((log) => (
                              <tr>
                                <td>{log.date}</td>
                                <td>
                                  {
                                    log.items &&
                                    <table className="table supply-order-product-item-table">
                                      <thead>
                                        <tr>
                                          <th>{t('SUPPLY_ORDER_LOGS.TABLE_BODY_HEAD.PRODUCT_CODE')}</th>
                                          <th>{t('SUPPLY_ORDER_LOGS.TABLE_BODY_HEAD.PRODUCT_QUANTITY')}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {
                                          JSON.parse(log.items).map((productItem) => (
                                            <tr>
                                              <td>{productItem.ProductCode}</td>
                                              <td>{productItem.ProductQuantity}</td>
                                            </tr>
                                          ))
                                        }
                                      </tbody>
                                    </table>
                                  }
                                </td>
                                <td>{log.status}</td>
                                <td>{(log.orderId) ? log.orderId : 'NA'}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </TabPane>
                  )) :
                  <TabPane tabId={TABS.SUPPLY_ORDER_LOG}>
                    <div className="email-log-error">{t("ERROR_CONTENT.SUPPLY_ORDER_LOGS")}</div>
                  </TabPane>
              }
            </TabContent>
          </div>
        </div> :
        supplyOrderLogs.error ?
          <div className="email-log-error">{t("ERROR_CONTENT.SUPPLY_ORDER_LOGS")}</div>
          : null
  );
}

export default SupplyOrderLogs;